import script from "./Help.vue?vue&type=script&setup=true&lang=js"
export * from "./Help.vue?vue&type=script&setup=true&lang=js"

import "./Help.vue?vue&type=style&index=0&id=71567f62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71567f62"]])

export default __exports__